import { FormattedMessage } from 'react-intl';

import PendingStatusSVG from './pendingStatusSVG/PendingStatusSVG';
import messages from './PendingView.messages';
import styles from './PendingView.module.css';
import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper';

export const PendingView = () => (
    <MainSectionWrapper className="col-span-full">
        <div className={styles.pendingStatus}>
            <PendingStatusSVG className={styles.PendingViewSVG} />

            <div className={styles.title}>
                <FormattedMessage {...messages.title} />
            </div>

            <div className={styles.subtitle}>
                <FormattedMessage {...messages.subtitle} />
            </div>
        </div>
    </MainSectionWrapper>
);
